<template>
  <div class="max-w-6xl mx-auto mt-10 mb-10" v-if="page">
    <h1
      class="font-sans text-xl font-semibold text-center md:text-center md:font-bold md:text-3xl"
    >
      {{ page.title }}
    </h1>
    <p class="py-3 mt-4 text-gray-700" v-html="page.description"></p>
  </div>
</template>
<script>
// import { ref } from "vue";
import { useGetData } from "@/composables/useGetData";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export default {
  components: {},
  setup() {
    const router = useRouter();
    const store = useStore();
    const base_url = store.state.baseUrl;
    let routeValue = router.currentRoute.value;
    const slug = routeValue.params.slug;
    const {
      data: page,
      error: pageError,
      fetchData: fetchPageData,
    } = useGetData(`${base_url}footer-pages/${slug}`);

    return {
      page,
      pageError,
      fetchPageData,
    };
  },
};
</script>
